import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';

import { authHttpClient } from 'services/httpClient';
import IResetPasswordRequestBody from 'services/httpClient/requests/auth/IResetPasswordRequestBody';

import { authActions } from '../index';
import { IResetPasswordRequestAction } from '../reducers/resetPassword/request';

function* resetPassword(action: PayloadAction<IResetPasswordRequestAction>) {
  try {
    const body: IResetPasswordRequestBody = {
      password: action.payload.data.newPassword,
      password_confirmation: action.payload.data.confirmNewPassword,
      reset_password_token: action.payload.data.resetPasswordToken,
    };

    authHttpClient.defaults.headers.common['access-token'] =
      action.payload.data.userData.token;
    authHttpClient.defaults.headers.common.client =
      action.payload.data.userData.client;
    authHttpClient.defaults.headers.common.uid =
      action.payload.data.userData.uid;

    yield call(authHttpClient.put, 'auth/password', body);

    yield put(authActions.resetPasswordSuccess());
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(authActions.resetPasswordFailure());
  }
}

export default resetPassword;
